import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PlayCircleIcon, CheckCircleIcon, ClockIcon, AwardIcon, SearchIcon, ShieldIcon, CloudIcon, DatabaseIcon, BotIcon, LineChartIcon, LayoutIcon, MegaphoneIcon, BriefcaseIcon, ZapIcon } from 'lucide-react';
const categories = ['All', 'Agentic AI & AI Operations', 'Cybersecurity', 'Cloud Computing', 'Data Analytics & Engineering', 'Sales & Revenue Operations', 'UX/UI Design', 'Digital Marketing', 'Project Management', 'Automation & No-Code'];
const courses = [
// Agentic AI
{
  id: 1,
  title: 'Building Agentic AI Systems',
  provider: 'OpenAI',
  category: 'Agentic AI & AI Operations',
  duration: '12 hours',
  difficulty: 'Intermediate',
  progress: 0,
  thumbnail: 'from-primary-600 to-primary-800',
  completed: false,
  learners: '1.2k',
  desc: 'Design and deploy autonomous AI agents.'
}, {
  id: 2,
  title: 'Prompt Engineering Masterclass',
  provider: 'Anthropic',
  category: 'Agentic AI & AI Operations',
  duration: '6 hours',
  difficulty: 'Beginner',
  progress: 0,
  thumbnail: 'from-primary-400 to-primary-600',
  completed: false,
  learners: '3.4k',
  desc: 'Master advanced prompting techniques.'
}, {
  id: 3,
  title: 'AI Operations & MLOps',
  provider: 'Google Cloud',
  category: 'Agentic AI & AI Operations',
  duration: '20 hours',
  difficulty: 'Advanced',
  progress: 0,
  thumbnail: 'from-primary-700 to-primary-900',
  completed: false,
  learners: '850',
  desc: 'Manage machine learning lifecycles.'
},
// Cybersecurity
{
  id: 4,
  title: 'CompTIA Security+ Prep',
  provider: 'CompTIA',
  category: 'Cybersecurity',
  duration: '40 hours',
  difficulty: 'Intermediate',
  progress: 0,
  thumbnail: 'from-surface-600 to-surface-800',
  completed: false,
  learners: '5.1k',
  desc: 'Comprehensive prep for Security+ certification.'
}, {
  id: 5,
  title: 'Ethical Hacking Fundamentals',
  provider: 'EC-Council',
  category: 'Cybersecurity',
  duration: '30 hours',
  difficulty: 'Beginner',
  progress: 0,
  thumbnail: 'from-surface-500 to-surface-700',
  completed: false,
  learners: '2.8k',
  desc: 'Learn offensive security basics.'
}, {
  id: 6,
  title: 'SOC Analyst Training',
  provider: 'Splunk',
  category: 'Cybersecurity',
  duration: '25 hours',
  difficulty: 'Intermediate',
  progress: 0,
  thumbnail: 'from-surface-700 to-surface-900',
  completed: false,
  learners: '1.5k',
  desc: 'Monitor and analyze security events.'
},
// Cloud Computing
{
  id: 7,
  title: 'AWS Solutions Architect Associate',
  provider: 'Amazon Web Services',
  category: 'Cloud Computing',
  duration: '40 hours',
  difficulty: 'Intermediate',
  progress: 65,
  thumbnail: 'from-amber-500 to-amber-700',
  completed: false,
  learners: '8.2k',
  desc: 'Design distributed systems on AWS.'
}, {
  id: 8,
  title: 'Azure Fundamentals AZ-900',
  provider: 'Microsoft',
  category: 'Cloud Computing',
  duration: '8 hours',
  difficulty: 'Beginner',
  progress: 100,
  thumbnail: 'from-blue-500 to-blue-700',
  completed: true,
  learners: '6.4k',
  desc: 'Core cloud concepts on Azure.'
}, {
  id: 9,
  title: 'Google Cloud Digital Leader',
  provider: 'Google',
  category: 'Cloud Computing',
  duration: '12 hours',
  difficulty: 'Beginner',
  progress: 0,
  thumbnail: 'from-emerald-500 to-emerald-700',
  completed: false,
  learners: '3.1k',
  desc: 'Foundational cloud knowledge.'
},
// Data
{
  id: 10,
  title: 'Data Analysis with Python',
  provider: 'IBM',
  category: 'Data Analytics & Engineering',
  duration: '30 hours',
  difficulty: 'Intermediate',
  progress: 0,
  thumbnail: 'from-primary-500 to-primary-700',
  completed: false,
  learners: '4.5k',
  desc: 'Analyze data using Pandas and NumPy.'
}, {
  id: 11,
  title: 'SQL for Data Engineering',
  provider: 'DataCamp',
  category: 'Data Analytics & Engineering',
  duration: '15 hours',
  difficulty: 'Beginner',
  progress: 0,
  thumbnail: 'from-primary-400 to-primary-600',
  completed: false,
  learners: '5.8k',
  desc: 'Master database querying and design.'
}, {
  id: 12,
  title: 'Power BI Dashboard Design',
  provider: 'Microsoft',
  category: 'Data Analytics & Engineering',
  duration: '10 hours',
  difficulty: 'Beginner',
  progress: 0,
  thumbnail: 'from-primary-300 to-primary-500',
  completed: false,
  learners: '3.9k',
  desc: 'Create interactive data visualizations.'
},
// Sales & RevOps
{
  id: 13,
  title: 'Salesforce Administrator Cert',
  provider: 'Salesforce',
  category: 'Sales & Revenue Operations',
  duration: '35 hours',
  difficulty: 'Intermediate',
  progress: 0,
  thumbnail: 'from-blue-400 to-blue-600',
  completed: false,
  learners: '4.1k',
  desc: 'Manage and configure Salesforce.'
}, {
  id: 14,
  title: 'Revenue Operations Fundamentals',
  provider: 'HubSpot',
  category: 'Sales & Revenue Operations',
  duration: '8 hours',
  difficulty: 'Beginner',
  progress: 0,
  thumbnail: 'from-orange-400 to-orange-600',
  completed: false,
  learners: '1.8k',
  desc: 'Align sales, marketing, and service.'
},
// Others
{
  id: 15,
  title: 'Google UX Design Certificate',
  provider: 'Google',
  category: 'UX/UI Design',
  duration: '20 hours',
  difficulty: 'Beginner',
  progress: 0,
  thumbnail: 'from-pink-500 to-pink-700',
  completed: false,
  learners: '7.2k',
  desc: 'Foundations of user experience design.'
}, {
  id: 16,
  title: 'Google Digital Marketing',
  provider: 'Google',
  category: 'Digital Marketing',
  duration: '24 hours',
  difficulty: 'Beginner',
  progress: 0,
  thumbnail: 'from-teal-400 to-teal-600',
  completed: false,
  learners: '5.5k',
  desc: 'E-commerce and marketing basics.'
}, {
  id: 17,
  title: 'Agile & Scrum Mastery',
  provider: 'Atlassian',
  category: 'Project Management',
  duration: '12 hours',
  difficulty: 'Intermediate',
  progress: 0,
  thumbnail: 'from-indigo-400 to-indigo-600',
  completed: false,
  learners: '3.6k',
  desc: 'Lead agile development teams.'
}, {
  id: 18,
  title: 'Zapier & Make Automation',
  provider: 'Zapier',
  category: 'Automation & No-Code',
  duration: '6 hours',
  difficulty: 'Beginner',
  progress: 0,
  thumbnail: 'from-amber-400 to-orange-500',
  completed: false,
  learners: '2.4k',
  desc: 'Automate workflows without code.'
}];
const earnedCertifications = [{
  title: 'Azure Fundamentals',
  provider: 'Microsoft',
  date: 'Oct 2023',
  icon: CloudIcon,
  color: 'text-blue-600',
  bg: 'bg-blue-50'
}, {
  title: 'IT Support Professional',
  provider: 'Google',
  date: 'Aug 2023',
  icon: ShieldIcon,
  color: 'text-emerald-600',
  bg: 'bg-emerald-50'
}, {
  title: 'Career Readiness',
  provider: 'EquityPath',
  date: 'Jul 2023',
  icon: AwardIcon,
  color: 'text-primary-600',
  bg: 'bg-primary-50'
}];
export function LearningHub() {
  const [activeCategory, setActiveCategory] = useState('All');
  const filteredCourses = activeCategory === 'All' ? courses : courses.filter(c => c.category === activeCategory);
  return <div className="space-y-8 pb-8" data-id="element-488">
      {/* Header */}
      <div data-id="element-489">
        <h1 className="text-2xl font-bold text-surface-900 tracking-tight" data-id="element-490">
          Learning Hub
        </h1>
        <p className="text-surface-500 text-sm mt-1" data-id="element-491">
          Develop future-ready skills with industry-recognized certifications.
        </p>
      </div>

      {/* Active Learning Banner */}
      <div className="bg-primary-900 rounded-2xl p-6 sm:p-8 text-white relative overflow-hidden shadow-xl" data-id="element-492">
        <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 w-64 h-64 bg-primary-600 rounded-full blur-3xl opacity-50" data-id="element-493" />

        <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-494">
          <div className="max-w-xl" data-id="element-495">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-white/10 text-primary-100 text-xs font-semibold uppercase tracking-wider mb-4" data-id="element-496">
              <PlayCircleIcon className="w-3.5 h-3.5" data-id="element-497" />
              Continue Learning
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold mb-2" data-id="element-498">
              AWS Solutions Architect Associate
            </h2>
            <p className="text-primary-100 text-sm mb-6" data-id="element-499">
              Module 4: Virtual Private Clouds (VPCs) and Networking
              Fundamentals.
            </p>

            <div className="flex items-center gap-4" data-id="element-500">
              <div className="flex-1 max-w-xs" data-id="element-501">
                <div className="flex justify-between text-xs text-primary-100 mb-1.5" data-id="element-502">
                  <span data-id="element-503">Progress</span>
                  <span data-id="element-504">65%</span>
                </div>
                <div className="w-full bg-primary-950 rounded-full h-2" data-id="element-505">
                  <div className="bg-primary-400 h-2 rounded-full" style={{
                  width: '65%'
                }} data-id="element-506"></div>
                </div>
              </div>
            </div>
          </div>

          <button className="bg-white text-primary-900 px-6 py-3 rounded-xl text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap self-start md:self-auto" data-id="element-507">
            Resume Course
          </button>
        </div>
      </div>

      {/* Categories & Search */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sticky top-0 bg-surface-50/80 backdrop-blur-md py-4 z-10" data-id="element-508">
        <div className="flex overflow-x-auto pb-2 sm:pb-0 w-full sm:w-auto hide-scrollbar gap-2" data-id="element-509">
          {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeCategory === cat ? 'bg-primary-900 text-white' : 'bg-white text-surface-600 border border-surface-200 hover:bg-surface-50'}`} data-id="element-510">
              {cat}
            </button>)}
        </div>

        <div className="relative w-full sm:w-64 shrink-0" data-id="element-511">
          <SearchIcon className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-surface-400" data-id="element-512" />
          <input type="text" placeholder="Search courses..." className="w-full pl-9 pr-4 py-2 bg-white border border-surface-200 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500" data-id="element-513" />
        </div>
      </div>

      {/* Course Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-514">
        {filteredCourses.map(course => <motion.div key={course.id} layout initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.2
      }} className="bg-white rounded-2xl border border-surface-200 overflow-hidden hover:shadow-lg hover:border-primary-200 transition-all group flex flex-col" data-id="element-515">
            {/* Thumbnail Area */}
            <div className={`h-32 bg-gradient-to-br ${course.thumbnail} relative p-4 flex flex-col justify-between`} data-id="element-516">
              <div className="flex justify-between items-start" data-id="element-517">
                <span className="bg-white/20 backdrop-blur-md text-white text-xs font-semibold px-2.5 py-1 rounded-md" data-id="element-518">
                  {course.category}
                </span>
                {course.completed && <div className="bg-emerald-500 text-white p-1 rounded-full shadow-sm" data-id="element-519">
                    <CheckCircleIcon className="w-4 h-4" data-id="element-520" />
                  </div>}
              </div>
            </div>

            {/* Content Area */}
            <div className="p-5 flex-1 flex flex-col" data-id="element-521">
              <div className="flex-1" data-id="element-522">
                <p className="text-xs font-medium text-surface-500 mb-1" data-id="element-523">
                  {course.provider}
                </p>
                <h3 className="text-base font-semibold text-surface-900 leading-tight mb-2 group-hover:text-primary-600 transition-colors" data-id="element-524">
                  {course.title}
                </h3>
                <p className="text-sm text-surface-600 mb-4 line-clamp-1" data-id="element-525">
                  {course.desc}
                </p>

                <div className="flex items-center gap-4 text-xs text-surface-500 mb-4" data-id="element-526">
                  <div className="flex items-center gap-1" data-id="element-527">
                    <ClockIcon className="w-3.5 h-3.5" data-id="element-528" />
                    {course.duration}
                  </div>
                  <div className="flex items-center gap-1" data-id="element-529">
                    <AwardIcon className="w-3.5 h-3.5" data-id="element-530" />
                    {course.difficulty}
                  </div>
                  <div className="flex items-center gap-1" data-id="element-531">
                    <UsersIcon className="w-3.5 h-3.5" data-id="element-532" />
                    {course.learners}
                  </div>
                </div>
              </div>

              {/* Progress or Action */}
              <div className="pt-4 border-t border-surface-100 mt-auto" data-id="element-533">
                {course.progress > 0 ? <div data-id="element-534">
                    <div className="flex justify-between text-xs font-medium mb-1.5" data-id="element-535">
                      <span className={course.completed ? 'text-emerald-600' : 'text-primary-600'} data-id="element-536">
                        {course.completed ? 'Completed' : 'In Progress'}
                      </span>
                      <span className="text-surface-500" data-id="element-537">
                        {course.progress}%
                      </span>
                    </div>
                    <div className="w-full bg-surface-100 rounded-full h-1.5" data-id="element-538">
                      <div className={`h-1.5 rounded-full ${course.completed ? 'bg-emerald-500' : 'bg-primary-600'}`} style={{
                  width: `${course.progress}%`
                }} data-id="element-539" />
                    </div>
                  </div> : <button className="w-full py-2 text-sm font-medium text-surface-700 bg-surface-50 hover:bg-surface-100 rounded-lg transition-colors border border-surface-200" data-id="element-540">
                    Start Course
                  </button>}
              </div>
            </div>
          </motion.div>)}
      </div>

      {/* Certifications Earned */}
      <div className="mt-12" data-id="element-541">
        <h2 className="text-lg font-semibold text-surface-900 mb-4" data-id="element-542">
          Certifications Earned
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-543">
          {earnedCertifications.map((cert, i) => <div key={i} className="bg-white p-4 rounded-xl border border-surface-200 shadow-sm flex items-center gap-4" data-id="element-544">
              <div className={`w-12 h-12 rounded-lg ${cert.bg} flex items-center justify-center`} data-id="element-545">
                <cert.icon className={`w-6 h-6 ${cert.color}`} data-id="element-546" />
              </div>
              <div data-id="element-547">
                <h3 className="text-sm font-semibold text-surface-900" data-id="element-548">
                  {cert.title}
                </h3>
                <p className="text-xs text-surface-500" data-id="element-549">
                  {cert.provider} • {cert.date}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}
function UsersIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-550">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" data-id="element-551" />
      <circle cx="9" cy="7" r="4" data-id="element-552" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" data-id="element-553" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-554" />
    </svg>;
}